<template>
  <div v-if="qrContent" class="card-info">
    <p class="created-date">{{ readingDate }}</p>
    {{ qrContent }}
  </div>
</template>

<script>
export default {
  props: {
    qrReading: {
      type: Object,
      required: true
    }
  },
  computed: {
    readingDate() {
      if (!(this.qrReading.created_at || false)) return 'not informed'

      const dateReading = new Date(
        this.qrReading.created_at.seconds * 1000
      ).toUTCString()
      return dateReading
    },
    qrContent() {
      return this.qrReading.text
    }
  }
}
</script>

<style>
.card-info {
  background-color: #419ef9;
  color: white;
  padding: 8px 16px;
  margin-bottom: 16px;
  text-align: start;
  border-radius: 0.2857rem;
  font-size: 16px;
  overflow-wrap: break-word;
}

.created-date {
  margin: 0 0 2px 0;
  padding: 0;
  font-size: 14px;
  font-weight: bold;
}
</style>
